/**
 * Created by simon zhao on 10/22/2021.
 * Description:
 * serves as the view model for process definition view.
 * ------ maintenance history ------
 */
import { ProcessDefinition } from '../../tamalelibs/models/workflow.model';
export class ProcessDefinitionViewModel {
    /**
     * the raw model of process definition.
     *
     * @type {ProcessDefinition}
     * @memberof ProcessDefinitionViewModel
     */
    definition: ProcessDefinition;
}
